import { Grid, Hidden, SelectableChipSmall, Tab, Tabs, useTheme } from '@paintscout/ui'
import React, { useEffect, useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import ProductionCalendar, {
  ProductionCalendarProvider,
  useProductionCalendar
} from 'src/components/common/ProductionCalendar'
import MapViewSwitcher from 'src/components/common/MapViewSwitcher'

function ProductionViewChips() {
  const theme = useTheme()
  const { view, setView, tab } = useProductionCalendar()
  const chipStyle = { backgroundColor: theme.paintscout.palette.brand.Neutral.P94 }
  return (
    <>
      {tab === 'calendar' && (
        <SelectableChipSmall
          label="Schedule"
          selected={view === 'agenda'}
          onClick={() => setView('agenda')}
          style={chipStyle}
        />
      )}
      <SelectableChipSmall label="Day" selected={view === 'day'} onClick={() => setView('day')} style={chipStyle} />
      <SelectableChipSmall label="Week" selected={view === 'week'} onClick={() => setView('week')} style={chipStyle} />
      <SelectableChipSmall
        label="Month"
        selected={view === 'month'}
        onClick={() => setView('month')}
        style={chipStyle}
      />
    </>
  )
}

function ProductionMobileViewSwitcher() {
  const { view, setView, tab } = useProductionCalendar()
  return <MapViewSwitcher value={view} onChange={setView} includeSchedule={tab === 'calendar'} />
}

export default function SchedulingView() {
  const [tab, setTab] = useState<'calendar' | 'map'>('calendar')
  const location = useLocation()
  const history = useHistory()

  useEffect(() => {
    // Set the tab based on the URL query parameter
    const params = new URLSearchParams(location.search)
    const tabParam = params.get('tab')
    if (tabParam === 'map' || tabParam === 'calendar') {
      setTab(tabParam)
    }
  }, [location.search])

  const handleTabChange = (_: React.ChangeEvent<any>, value: 'calendar' | 'map') => {
    setTab(value)
    history.push(`/scheduling/?tab=${value}`)
  }

  return (
    <ProductionCalendarProvider tab={tab}>
      <Grid container justifyContent="space-between" alignItems="center" spacing={1}>
        <Grid item>
          <Tabs value={tab} onChange={handleTabChange}>
            <Tab label="Calendar" value="calendar" />
            <Tab label="Map" value="map" />
          </Tabs>
        </Grid>

        {tab === 'calendar' && (
          <Hidden xsDown>
            <Grid item xs container justifyContent="flex-end" alignItems="center" style={{ gap: 8 }}>
              <ProductionViewChips />
            </Grid>
          </Hidden>
        )}

        <Hidden smUp>
          <Grid item>
            <ProductionMobileViewSwitcher />
          </Grid>
        </Hidden>

        <Grid item xs={12}>
          <ProductionCalendar />
        </Grid>
      </Grid>
    </ProductionCalendarProvider>
  )
}
